export default __webpack_public_path__ + "static/media/misc-closetC-1024w.76f042f0.png";